import React, {useState, useEffect} from 'react';
import * as Hubspot from './libraries/Hubspot.js';
import "./App.css";

const HubspotInputGroup = (props) => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(()=>{
    if( email==="" ){
      setError("");
    }
  },[email])

  const onBlur = async()=>{
    setError("");
    if( email==="" ) return;
    //if( !isValidEmail(email) ) return;
    (async () => {
      await isValidEmailAPI(email);
    })();
  }

  const isValidEmailAPI = async(email) =>{
    if( !isValidEmail(email) ){
      setError("Please input a valid email.");
      return;
    }
    let data = await Hubspot.checkEmail(props.portalId,props.formId,email);
    //console.log(data);
    if( data?.success === false ){
      setError("Please enter a valid email address.");
      return false;
    }
    else if( data?.emailFree === true ){
      const emailDomain = email.split("@")[1];
      setError("Please enter a different email address. This form does not accept addresses from "+emailDomain+".");
      return false;
    }
    return true;
  }

  const isValidEmail = (email) =>{
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  const submit = async() =>{
    let data;
    if( submitting ) return;
    if( error!=="" ) return;

    data = await isValidEmailAPI(email);
    if( !data ) return;

    setSuccess("");

    setSubmitting(true);
    data = await Hubspot.submit(props.portalId,props.formId,email);
    setSubmitting(false);
    //Peter@developmentcollective.io

    if( data?.inlineMessage ){
      setSuccess(data.inlineMessage);
      window.dispatchEvent( new CustomEvent("__hubspot_submitted", {detail: data.inlineMessage}) );

      // Clear success message after 10 seconds
      setTimeout(() => {
        setSuccess("");
      }, 10000); // 10 seconds
    }
    //console.log(data);
  }
  

  return (
    <>
      <div className={"input_group"+((error!=="")?" error":"")}>
        <input 
          maxLength="256" 
          placeholder="Email Address" 
          type="email" 
          value={email} 
          onChange={e=>setEmail(e.target.value)} 
          onBlur={onBlur}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault(); // Prevent form submission (if inside a form)
              submit();
            }
          }}
        />
        <button onClick={submit} disabled={submitting || (error!=="") }>{submitting?"Submitting...":"Submit"}</button>
      </div>
      {error ? (
        <div className="error_text">{error}</div>
      ) : null}
      {success ? (
        <div className="success_text">{success}</div>
      ) : null}
      
    </>
  );
}

export default HubspotInputGroup;